import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

/**
 * Reads the user's mailing address from the personalInformation slice
 * and exposes it both as raw fields and as ready-to-use, formatted
 * pieces (each with its trailing comma already applied where needed)
 * so screens don't have to repeat that formatting logic.
 */
const usePersonalAddress = () => {
  const {
    address1,
    address2,
    city,
    state,
    zipCode,
  } = useSelector(
    ({ personalInformation }) => personalInformation,
    shallowEqual,
  );

  const addressLine1 = useMemo(
    () => (address1 ? `${address1},` : ''),
    [address1],
  );

  const addressLine2 = useMemo(
    () => (address2 ? `${address2},` : ''),
    [address2],
  );

  const cityStateZip = useMemo(
    () => `${city}, ${state} ${zipCode}`,
    [city, state, zipCode],
  );

  return {
    address1,
    address2,
    addressLine1,
    addressLine2,
    city,
    cityStateZip,
    state,
    zipCode,
  };
};

export { usePersonalAddress };
